<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col">
          <h2>{{ title }} <span v-if="form.deceased" class="badge badge-info">Deceduto</span></h2>
        </div>
        <div class="col text-right">
          <button @click.prevent="close"
                  class="btn btn-primary">Chiudi
          </button>
          <button v-if="readonly && can('write people cards')"
                  @click.prevent="toggleReadonly"
                  class="btn btn-secondary">Modifica
          </button>
          <button v-if="readonly && can('delete people cards')"
                  @click.prevent="deleteCard"
                  class="btn btn-danger">Elimina
          </button>
          <button v-if="!readonly"
                  @click.prevent="save"
                  class="btn btn-success">Salva
          </button>
          <button v-if="!readonly"
                  @click.prevent="discardChanges"
                  class="btn btn-warning">Annulla modifiche
          </button>
        </div>
      </div>

      <people-card-form :form="form" :readonly="readonly" :type="type"/>

    </div>
  </section>
</template>

<script>
import PeopleCardForm from "../components/PeopleCardForm"
import sharedState from "../sharedState"
import peopleCards from "../services/api/peopleCards"
import {ref} from "vue"

export default {
  name: "PeopleCard",
  components: {
    PeopleCardForm,
  },
  data() {
    return {
      sharedState: sharedState,
      title: '',
      peopleCardId: null,
      form: null,
      readonly: false,
      type: 'show',
      originalData: null
    }
  },
  async created() {
    await this.initializeContent()
  },
  methods: {
    async initializeContent() {
      this.$isLoading(true)
      this.form = new Form()
      this.peopleCardId = this.$route.params.id
      if (this.peopleCardId) {
        try {
          let data = await this.getPeopleCardContent()
          this.originalData = data
          this.form = new Form(data)
          this.title = this.fullName
          sharedState.pushCardOpen({name: this.fullName, id: this.form.id, type: 'people'})
          this.readonly = true
        } catch (e) {
          console.error(e)
          Toast.fire({
            icon: 'error',
            title: 'Errore: impossibile recuperare i dati.'
          }).finally()
        }

      }
      this.$isLoading(false)
    },
    close() {
      let previousCard = sharedState.popCardOpened(this.form.id, 'people')
      this.$destroy()
      if (previousCard !== undefined) {
        this.$router.replace({path: `/${previousCard.type}-card/` + previousCard.id})
      } else {
        this.$router.replace({path: '/people-cards'})
      }
    },
    toggleReadonly() {
      this.readonly = !this.readonly
    },
    discardChanges() {
      this.form = new Form(this.originalData)
      this.toggleReadonly()
    },
    async save() {
      this.$isLoading(true)
      try {
        let response = await this.form.put(window.baseUrl + '/people-cards/' + this.peopleCardId)
        sharedState.updateCardOpen({name: this.fullName, id: this.form.id, type: 'people'})
        this.originalData = await this.getPeopleCardContent()
        Toast.fire({
          icon: 'success',
          title: response.data.message
        }).finally()
      } catch (e) {
        console.error(e)
        Toast.fire({
          icon: 'error',
          title: 'Errore: impossibile salvare il modulo.'
        }).finally()
      }
      this.toggleReadonly()
      this.$isLoading(false)
    },
    async deleteCard() {
      Swal.fire({
        title: 'Vuoi eliminare questa scheda?',
        showCancelButton: true,
        confirmButtonText: 'Elimina',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await peopleCards.delete(this.peopleCardId)
            this.$vnode.componentInstance.$parent.$children.forEach(component => {
              if (component.$vnode.key !== undefined && (component.$vnode.key.includes('/people-cards') || component.$vnode.key.includes('/people-cards/results'))) {
                let index = component.$vnode.componentInstance.$refs.vgt.rows.findIndex(row => row.id == this.peopleCardId)
                component.$vnode.componentInstance.$refs.vgt.rows.splice(index, 1)
              }
            })
            this.close()
          } catch (e) {
            Toast.fire({
              icon: 'error',
              title: 'Errore: impossibile eliminare la scheda.',
              html: e.response.data.message
            }).finally()
          }
        }
      })
    },
    async getPeopleCardContent() {
      let response = await peopleCards.show(this.peopleCardId)
      let data = response.data.data

      // Badge latest mapping
      if (response.data.data.badge_latest != null) {
        data.latestBadgeYear = response.data.data.badge_latest.edition.name
        data.badge_collected = response.data.data.badge_latest.badge_collected
        data.non_paying = response.data.data.badge_latest.non_paying
        data.badge_latest = response.data.data.badge_latest.badge_type_id
      }

      // Hospitality latest mapping
      if (response.data.data.hospitality_latest != null) {
        data.hospitality_type_id = response.data.data.hospitality_latest.hospitality_type_id
        data.hospitality_duration = response.data.data.hospitality_latest.duration
        data.hospitality_accomodation = response.data.data.hospitality_latest.accomodation
        data.hospitality_free = response.data.data.hospitality_latest.free
      }

      // Volunteer latest mapping
      data.is_volunteer = response.data.data.volunteer_latest != null

      return data
    }
  },
  computed: {
    fullName() {
      let first_name = (this.form.first_name !== null) ? this.form.first_name : ''
      let last_name = (this.form.last_name !== null) ? this.form.last_name : ''
      return last_name + ' ' + first_name
    }
  }
}
</script>

<style scoped>

</style>
